import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.sass']
})
export class PromotionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
